import { render, staticRenderFns } from "./ScoreCardFullScreenTableHorizontal.vue?vue&type=template&id=41433d6c&"
import script from "./ScoreCardFullScreenTableHorizontal.vue?vue&type=script&lang=js&"
export * from "./ScoreCardFullScreenTableHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCardFullScreenTableHorizontal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports